import { CloudUploadIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";

export const FilePreview = ({
  onSelect
}: {
  onSelect: (value: string) => void;
}) => {
  return (
    <button
      type="button"
      onClick={() => onSelect("file-placeholder.pdf")}
      className="h-[140px] gap-2 w-full flex justify-center items-center flex-col p-4 border rounded-md border-dashed border-primary-500 bg-primary-50 cursor-pointer hover:bg-primary-100 transition-colors"
    >
      <HugeiconsIcon
        size={24}
        className="text-primary-500"
        icon={CloudUploadIcon}
      />
      <p className="text-sm font-bold text-primary-500">
        Upload file or picture
      </p>
    </button>
  );
};
